<ng-container *ngIf="collectionIds$ | async as collectionIds">
  <div class="container header">
    <div class="title">Demo Library</div>
    <div class="description">
      Here you find all the demo assets you can use to create your Demo Environment.
      <br />
      <!-- You can either choose from <strong>Single Demos</strong> or choose a <strong>Suggested Demo set</strong> by using the tab on the
      right. -->
    </div>
  </div>
  <!-- <div class="container selector-container" *ngIf="defaultGroup">
    <div class="selector-button" [class]="{ selected: creationType === 'custom' }" (click)="setCreationType('custom')">
      single demos <mat-icon id="custom-info" svgIcon="help-16"></mat-icon>
    </div>
    <dx-tooltip
      target="#custom-info"
      showEvent="mouseenter"
      hideEvent="mouseleave"
      position="top"
      [hideOnOutsideClick]="false"
      [wrapperAttr]="{ class: 'wrapper-custom-tooltip' }"
      maxWidth="456px"
    >
      <div class="custom-tooltip" *dxTemplate="let data = data of 'content'">
        <div class="tooltip-title">Custom demo collection</div>
        <div class="tooltip-desc">
          Select the desired demos that you want to include in your collection.
          <ul>
            <li>Demos that work well together will be <strong class="highlighted">highlighted</strong> when any demo is selected</li>
            <li>
              Please consider that some options may not be available due to sizing and performance optimization. As selections are made,
              demos will be grayed out to ensure sizing and performance optimization.
            </li>
          </ul>
        </div>
      </div>
    </dx-tooltip>
    <div class="selector-button" [class]="{ selected: creationType === 'preset' }" (click)="setCreationType('preset')">
      suggested set <mat-icon id="preset-info" svgIcon="help-16"></mat-icon>
    </div>
    <dx-tooltip
      target="#preset-info"
      showEvent="mouseenter"
      hideEvent="mouseleave"
      position="top"
      [hideOnOutsideClick]="false"
      [wrapperAttr]="{ class: 'wrapper-custom-tooltip' }"
      maxWidth="456px"
    >
      <div class="custom-tooltip" *dxTemplate="let data = data of 'content'">
        <div class="tooltip-title">Suggested demo set</div>
        <div class="tooltip-desc">
          Choose from one of the available demos below and click “Create demo instance” to spin-up your own dedicated cloud environment.
          When ready, a new tile will appear in the “Your Demo Environments” section above.
        </div>
      </div>
    </dx-tooltip>
  </div> -->
  <div class="container filter-bar" *ngIf="defaultGroup">
    <div [class]="{ filters: true, expanded: expandFilters }">
      <div class="row">
        <brd-filter-dropdown
          *ngIf="filterCategories$ | async as filterCategories"
          [items]="filterCategories.categories"
          [selectedItems]="filterCategories.selectedCategories"
          filterName="category"
          [chipColor]="filterColors.category"
          (updateSelectedItems)="updateFilter($event)"
        ></brd-filter-dropdown>
        <brd-filter-dropdown
          *ngIf="filterDomains$ | async as filterDomains"
          [items]="filterDomains.domains"
          [selectedItems]="filterDomains.selectedDomains"
          [chipColor]="filterColors.domain"
          filterName="domain"
          (updateSelectedItems)="updateFilter($event)"
        ></brd-filter-dropdown>
        <brd-filter-dropdown
          *ngIf="filterProcesses$ | async as filterProcesses"
          [items]="filterProcesses.processes"
          [selectedItems]="filterProcesses.selectedProcesses"
          filterName="process"
          [chipColor]="filterColors.process"
          (updateSelectedItems)="updateFilter($event)"
        ></brd-filter-dropdown>
        <brd-filter-dropdown
          *ngIf="expandFilters && filterUseCases$ | async as filterUseCases"
          [items]="filterUseCases.useCases"
          [selectedItems]="filterUseCases.selectedUseCases"
          filterName="use cases"
          [chipColor]="filterColors.useCase"
          (updateSelectedItems)="updateFilter($event)"
        ></brd-filter-dropdown>
        <brd-button
          *ngIf="expandFilters"
          style="margin-left: auto"
          id="filter-expand"
          iconName="filter-16"
          color="secondary"
          matTooltip="Base filters"
          (clickEvent)="expandFilters = !expandFilters"
        ></brd-button>
      </div>
      <div class="row" style="flex: 1">
        <brd-filter-dropdown
          *ngIf="filterIndustries$ | async as filterIndustries"
          [items]="filterIndustries.industries"
          [selectedItems]="filterIndustries.selectedIndustries"
          filterName="industry"
          [chipColor]="filterColors.industry"
          (updateSelectedItems)="updateFilter($event)"
        ></brd-filter-dropdown>
        <brd-filter-dropdown
          *ngIf="expandFilters && filterFunctionalities$ | async as filterFunctionalities"
          [items]="filterFunctionalities.functionalities"
          [selectedItems]="filterFunctionalities.selectedFunctionalities"
          filterName="functionalities"
          [chipColor]="filterColors.functionality"
          (updateSelectedItems)="updateFilter($event)"
        ></brd-filter-dropdown>
        <dx-text-box
          class="search-filter"
          stylingMode="outlined"
          placeholder="Search"
          valueChangeEvent="input"
          (onValueChanged)="searchChange($event)"
        >
          <dxi-button name="search" location="before" [options]="searchButtonOptions"></dxi-button>
        </dx-text-box>
        <brd-button
          *ngIf="!expandFilters"
          id="filter-expand"
          iconName="filter-16"
          color="primary"
          matTooltip="Advanced filters"
          (clickEvent)="expandFilters = !expandFilters"
        ></brd-button>
      </div>
    </div>
    <ng-container *ngIf="filters$ | async as filterValues">
      <div class="selected-filters" *ngIf="filterValues.length">
        @for (filter of filterValues; track filter) {
          <mat-chip
            [ngStyle]="{
              borderColor: filter.color
            }"
          >
            {{ filter.name }}
            <mat-icon matChipRemove [attr.aria-label]="'remove ' + filter.name" (click)="updateFilter({ value: filter, action: 'REMOVE' })"
              >close</mat-icon
            >
          </mat-chip>
        }
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="defaultGroup; else notDefaultGroup">
    <ng-container *ngIf="creationType === 'custom' && demoAssets$ | async as assets">
      <div class="container" *ngIf="!loadingAssets; else loadingSpinner">
        <div class="cards" *ngIf="assets.length; else noAssets">
          <brd-demo-tile
            *ngFor="let asset of assets"
            [asset]="asset"
            [remainingCapacity]="remainingCapacity"
            [collectionIds]="collectionIds"
            [suggested]="suggestedDemos"
            [instancesQuotaExceeded]="instancesQuotaExceeded"
          ></brd-demo-tile>
        </div>
        <ng-template #noAssets>
          <div class="no-instances">NO DEMOS</div>
        </ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="creationType === 'preset' && demoTemplates$ | async as templates">
      <div class="container" *ngIf="!loadingTemplates; else loadingSpinner">
        <div class="cards-template" *ngIf="templates.length; else noTemplates">
          <brd-template-tile
            *ngFor="let template of templates"
            [template]="template"
            [enableAction]="!instancesQuotaExceeded"
          ></brd-template-tile>
        </div>
        <ng-template #noTemplates>
          <div class="no-instances">NO TEMPLATES</div>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>
  <div class="create-instance-container" *ngIf="collectionIds.length && creationType === 'custom' && !instancesQuotaExceeded">
    <div class="instance-counter">{{ collectionIds.length }}</div>
    <div class="text-container">
      Create and customize your own demo set!
      <brd-button color="primary" text="create" iconName="plus-16" (clickEvent)="createInstanceClick($event)"></brd-button>
    </div>
  </div>
  <ng-template #loadingSpinner>
    <div class="container loader">
      <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
    </div>
  </ng-template>
  <ng-template #completeDialog let-data="data">
    <div class="complete-dialog-container">
      <div class="text">
        Your Demo Instance is being set up and may take from 5 to 30 minutes to complete, depending on the instance size. You can check its
        progress in the Active Demo Environments section. When complete, you'll get an email notification.
      </div>
      <div class="button">
        <brd-button text="OK" color="primary" (clickEvent)="closeDialog()"></brd-button>
      </div>
    </div>
  </ng-template>
  <ng-template #notDefaultGroup>
    <div class="container not-default-group">
      You can't create demos in this group.<br />Please reset the filter to the default value if you'd like to start a new one. Thanks!
    </div>
  </ng-template>
</ng-container>
